export enum EPaymentDirectStatus {
  Selected = 'Selected',
  Submitted = 'Submitted',
  EmailSent = 'EmailSent',
  Posted = 'Posted',
  Assigned = 'Assigned'
}
